import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AreaType } from 'app/com/ibm/tw/commons/enums/global/area.type';
import { DirectUtils } from 'app/com/ibm/tw/commons/utils/direct.utils';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { HttpService, StatusService } from 'ui-components/common';
import { AxthenticationService } from '../../../services/axthentication.service';
import { ShareService } from '../../../services/share.service';
import { StringUtils } from './../../../com/ibm/tw/commons/utils/string.utils';
import { TxnService } from './../../../services/txn.service';
import { CcmhmannoHomeViewForm } from './../../chm/ccmhmanno/home/ccmhmanno.home.viewform';
import { CcmotlgacHomeViewForm } from './home/ccmotlgac.home.viewform';

declare var gibmsg: any;

@Injectable({
    providedIn: 'root'
})
export class CcmotlgacService extends TxnService {
    constructor(
        protected http: HttpService,
        protected shareService: ShareService,
        protected router: Router,
        protected axthenticationService: AxthenticationService,
        protected statusService: StatusService
    ) {
        super(http, shareService, router, axthenticationService, statusService);
    }

    /**
     * Post資料至後端
     * @param {GuestViewForm} viewForm 當前頁面的viewForm
     * @param {GuestViewForm} prototype 使用new建立的當前viewForm
     * @param {string} toMethod 呼叫後端的方法
     */
    post<T extends CcmotlgacHomeViewForm>(viewForm: T, prototype: T, toMethod: string): Observable<CcmotlgacHomeViewForm> {
        let toUrl = viewForm.navigatePage + '.' + toMethod;
        toUrl = DirectUtils.parseToPostUrl(toUrl);
        return this.doPostToBackEnd<CcmotlgacHomeViewForm>(viewForm, prototype, toUrl);
    }

    /**
     * 在進入到login頁面時，將登入token清除
     */
    logout() {
        this.axthenticationService.logout();
    }

    /**
     * 依客戶的uid判斷要使用哪一台Gateway
     * @param uid
     */
    validateAccount(uid: string) {
        // console.log('uid==' + uid.substring(0, 2));
        if (StringUtils.equals(uid.substring(0, 2), 'HK')) {
            this.httpService.server = environment.hkServer;
            this.shareService.currentArea = AreaType.HK;
        } else if (StringUtils.equals(uid.substring(0, 2), 'VN')) {
            this.httpService.server = environment.vnServer;
            this.shareService.currentArea = AreaType.VN;
        } else if (StringUtils.equals(uid.substring(0, 2), 'AU')) {
            this.httpService.server = environment.auServer;
            this.shareService.currentArea = AreaType.AU;
        } else if (StringUtils.equals(uid.substring(0, 2), 'KH')) {
            this.httpService.server = environment.khServer;
            this.shareService.currentArea = AreaType.KH;
        } else if (StringUtils.equals(uid.substring(0, 2), 'MM')) {
            this.httpService.server = environment.mmServer;
            this.shareService.currentArea = AreaType.MM;
        } else if (StringUtils.equals(uid.substring(0, 2), 'SG')) {
            this.httpService.server = environment.sgServer;
            this.shareService.currentArea = AreaType.SG;
        } else if (StringUtils.equals(uid.substring(0, 2), 'US')) {
            this.httpService.server = environment.usServer;
            this.shareService.currentArea = AreaType.US;
        } else {
            this.httpService.server = environment.twServer;
            this.shareService.currentArea = AreaType.TW;
        }

        // console.log('this.httpService.server =' + this.httpService.server);
    }

    updateAuthAfterLang(viewForm: CcmhmannoHomeViewForm) {

        this.axthenticationService.menu = viewForm.menu;
        this.axthenticationService.currentMenuId = viewForm.taskIxd;

        if (viewForm.menu !== null && !(viewForm.menu === undefined)) {
            if (this.axthenticationService.menu.menuCategory !== null && !(viewForm.menu.menuCategory === undefined)) {
                this.axthenticationService.menuCategory = viewForm.menu.menuCategory;
            }
        }

        // 預設的timeout時間
        if (viewForm.timeoutSecond > 0) {
            this.axthenticationService.defaultTimeoutSecond = viewForm.timeoutSecond;
        }

        this.axthenticationService.resetTimer();
        // 將登入後取得的token放至axthenticationService
        this.axthenticationService.token = viewForm.token;
        this.axthenticationService.isLoggedIn = true;
        // 一開始登入後的gib Current Areak 就是Company Area, 之後不會再做變更
        this.axthenticationService.companyAreaType = viewForm.gibCurrentArea;

        // 所屬公司的地區
        this.axthenticationService.currentArea = viewForm.gibCurrentArea;
        this.axthenticationService.userAreaOptions = viewForm.userAreaOptions;
        this.axthenticationService.welcomePage = viewForm.basePath + '.' + viewForm.navigatePage;
        this.axthenticationService.setToken(viewForm.token);
        this.axthenticationService.taskUrl = viewForm.taskUrl;

        if (viewForm.welcomeBean) {
            this.axthenticationService.historyList = viewForm.welcomeBean.accessLogList;
            this.axthenticationService.favoriteTaskList = viewForm.welcomeBean.favoriteTaskList;
        }

        this.goToNextPage(viewForm);
    }

}
